module.exports = __webpack_public_path__ + "static/assets/866982bcdcd862771766030e62c6e55e.png";